export const created = (actionsState, uploaderInstance) => {
  if (!actionsState?.attachments) return;

  uploaderInstance.createFileList(actionsState.attachments);
    
  document.querySelector('.e-file-select-wrap')?.remove();
  document.getElementById('uploader-browse')?.remove();
};